/**
 * AgentStats Class.
 *
 * @module AgentStats
 **/
export default class AgentStats {
  /**
   * @constructor
   * @this {AgentStats}
   *
   * @param {Object} rawAgentStats - Business Process stats information.
   **/
  constructor({
    agentId,
    agentName,
    agentASA,
    agentAnsweredAsConsultOrConference,
    agentAverageTreatingTime,
    agentBPAnsweredCalls,
    agentBackOfficeTime,
    agentBreakTime,
    agentBusyToLoginTimeRatio,
    agentCurrentBackOfficeTime,
    agentCurrentBreakTime,
    agentCurrentBusyTime,
    agentCurrentHandling,
    agentCurrentHandlingOutgoingTime,
    agentCurrentInteractionHandlingTime,
    agentCurrentReadyTime,
    agentCurrentTimeInWrapUp,
    agentHandlingEfficiencyScore,
    agentInBreakScore,
    agentLastLoginTime,
    agentLoginTimeSpan,
    agentMissedCalls,
    agentRejectedCalls,
    agentTimeInState,
    agentTotalAnsweredCalls,
    agentTotalBusyTime,
    agentTotalCallbacksReschedule,
    agentTotalConsultOrConference,
    agentTotalDialingTime,
    agentTotalHandlingOutgoingTime,
    agentTotalIdleTime,
    agentTotalIncomingCalls,
    agentTotalIncomingPrivateCalls,
    agentTotalNoAnswerTime,
    agentTotalNotReadyTime,
    agentTotalOutgoingExternalBPCalls,
    agentTotalOutgoingInternalBPCalls,
    agentTotalOutgoingPrivateCalls,
    agentTotalReadyTime,
    agentTotalTransfer,
    agentTotalUnsuccessfulDialingAttempts,
    agentTotalUnsuccessfulDialingTime,
    agentWorkingTime,
    agentWrapUpTimeInShift
  }) {
    Object.assign(this, ...arguments);
  }

  /**
   * Public getters
   */

  get isHandling() {
    return !!this.agentCurrentHandling.value;
  }

  get handlingTime() {
    return this.agentCurrentInteractionHandlingTime.value;
  }

  get totalAnsweredInteractions() {
    return this.agentTotalAnsweredCalls.value;
  }

  get totalMissedInteractions() {
    return this.agentMissedCalls.value;
  }

  get totalRejectedInteractions() {
    return this.agentRejectedCalls.value;
  }

  get totalTransferredInteractions() {
    return this.agentTotalTransfer.value;
  }

  get answeredInteractions() {
    return this.getDimensions('agentTotalAnsweredCalls');
  }

  get missedInteractions() {
    return this.getDimensions('agentMissedCalls');
  }

  get rejectedInteractions() {
    return this.getDimensions('agentRejectedCalls');
  }

  get transferredInteractions() {
    return this.getDimensions('agentTotalTransfer');
  }

  get handlingIcon() {
    const handling = this.getDimensions('agentCurrentHandling');

    if (handling.telephony) {
      return 'mdi-phone';
    }
    if (handling.email) {
      return 'mdi-email';
    }
    if (handling.chat) {
      return 'mdi-message-text';
    }
    if (handling.sms) {
      return 'mdi-chat-processing-outline';
    }

    return null;
  }

  getDimensions(key) {
    return {
      telephony: (this.findDimension(key, 'Telephony') || {}).value,
      email: (this.findDimension(key, 'E-mail') || {}).value,
      chat: (this.findDimension(key, 'Chat') || {}).value,
      sms: (this.findDimension(key, 'SMS') || {}).value
    };
  }

  findDimension(stat, dimensionName) {
    return this[stat].dimensionsValues.find(d => d.name === dimensionName);
  }
}
